import { FindStatementByPlan } from '../components/mission-statement/MissionSummary';
import React, { useState } from 'react';
import { UPDATE_STATEMENT } from '../../queries';
import { useMutation } from '@apollo/client';
import { Loading } from '../../../../components';
import TiptapEditor from '../../../../components/Tiptap/TiptapEditor';

interface MissionFormProps {
  data: FindStatementByPlan;
  onCancel: () => void;
  type: 'objective' | 'scope';
}

export function MissionForm({ data, onCancel, type }: MissionFormProps) {
  const [errorMessages, setErrorMessages] = useState('');
  const [UpdateStatement, { loading, error }] = useMutation(UPDATE_STATEMENT, {
    refetchQueries: ['FindStatementByPlan'],
  });

  if (loading) return <Loading />;
  if (error)
    return (
      <span className="text-danger font-bold text-center text-sm">
        Error! {error.message}
      </span>
    );

  const onFinish = async (value: string) => {
    let response;

    if (type === 'objective') {
      try {
        response = await UpdateStatement({
          variables: {
            data: {
              uuid: data.uuid,
              corporateObjectiveSummary: value,
              corporatePlanScopeSummary:
                data.corporatePlanScopeSummary.length > 0
                  ? data.corporatePlanScopeSummary
                  : ' ',
            },
          },
        });
        if (response?.data) {
          setErrorMessages('');
          onCancel();
        }
      } catch (error: any) {
        setErrorMessages(error.message);
      }
    } else {
      try {
        response = await UpdateStatement({
          variables: {
            data: {
              uuid: data.uuid,
              corporateObjectiveSummary:
                data.corporateObjectiveSummary.length > 0
                  ? data.corporateObjectiveSummary
                  : ' ',
              corporatePlanScopeSummary: value,
            },
          },
        });
        if (response?.data) {
          setErrorMessages('');
          onCancel();
        }
      } catch (error: any) {
        setErrorMessages(error.message);
      }
    }
  };

  return (
    <div className="  w-full flex flex-col flex-nowrap">
      <TiptapEditor
        onFinished={onFinish}
        initialContent={
          type === 'objective'
            ? data.corporateObjectiveSummary
            : data.corporatePlanScopeSummary
        }
      />
      <span>{errorMessages}</span>
    </div>
  );
}
